import { useFlags } from "launchdarkly-react-client-sdk";
import isNumber from "lodash/isNumber";
import { KnownFlag } from "./types";

type Flags = ReturnType<typeof useFlags>;

// For testing purposes only
export const fromFlags = (flags: Flags, flag: KnownFlag): number => {
  const value = flags[flag];

  if (!isNumber(value)) return -1; // -1 represents "off"

  return Number(value);
};

export const useFlagVersion = (flag: KnownFlag | undefined): number => {
  const flags = useFlags();

  if (flag === undefined) return 0; // 0 represents "on"

  return fromFlags(flags, flag);
};
